(function () {
  'use strict';

  function initialize(root) {
    if (root.dataset.minoxInitialized) return;
    root.dataset.minoxInitialized = 'true';

    const incoming = new URLSearchParams(window.location.search);
    root.querySelectorAll('a.cta').forEach(function (link) {
      const target = new URL(link.getAttribute('href'), window.location.origin);
      incoming.forEach(function (value, key) {
        if (/^utm_/i.test(key) || key === 'fbclid') target.searchParams.set(key, value);
      });
      link.href = target.toString();
    });

    root.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      const track = carousel.querySelector('[data-track]');
      const dots = carousel.querySelector('[data-dots]');
      const cards = Array.from(track.children);
      if (!cards.length) return;

      function step() {
        return cards[0].getBoundingClientRect().width + 16;
      }
      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }
      // Wider screens show three cards at once, so the track cannot scroll far
      // enough to bring every card to the left edge. One dot per position the
      // track can actually reach, recounted whenever the width changes.
      function pageCount() {
        const width = step();
        if (width <= 0) return 1;
        return Math.min(cards.length, Math.max(1, Math.round(maxScroll() / width) + 1));
      }
      function positionFor(index) {
        return Math.min(index * step(), maxScroll());
      }
      function sync() {
        const width = Math.max(1, step());
        const last = dots.children.length - 1;
        const index = Math.max(0, Math.min(last, Math.round(track.scrollLeft / width)));
        Array.from(dots.children).forEach(function (dot, position) {
          dot.setAttribute('aria-current', String(position === index));
        });
      }
      function buildDots() {
        const total = pageCount();
        if (dots.children.length === total) { sync(); return; }
        dots.textContent = '';
        for (let index = 0; index < total; index += 1) {
          const dot = document.createElement('button');
          dot.className = 'carousel__dot';
          dot.setAttribute('aria-label', 'Review ' + (index + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({ left: positionFor(index), behavior: 'smooth' });
          });
          dots.appendChild(dot);
        }
        sync();
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      carousel.querySelector('[data-prev]').addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      carousel.querySelector('[data-next]').addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      let resizeFrame = 0;
      window.addEventListener('resize', function () {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(buildDots);
      }, { passive: true });
      buildDots();
    });
  }

  document.querySelectorAll('.clc-without-minox01').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.clc-without-minox01').forEach(initialize);
  });
}());
